import { useSystemDegradationStatus } from '@phx/maintenance';

import { useFlags } from './use-flags';

export const useAppSystemDegradationStatus = () => {
    const { myPhxSystemDegradationBanner } = useFlags();
    return useSystemDegradationStatus(myPhxSystemDegradationBanner);
};
